module.exports = __webpack_public_path__ + "static/01-5ea860c7517890513040b52e7532a9f3.jpg";